// @flow
import { fetchMe } from './user.actions';
export const ADD_ITEM = 'item/ADD';
export const REM_ITEM = 'item/REM';

export const addItem = ({ dim }: { dim: any }) => ({
  type: ADD_ITEM,
  data: dim
});
export const removeItem = ({ dim }: { dim: any }) => ({
  type: REM_ITEM,
  data: dim
});

export default {
  addItem,
  removeItem
};



// WEBPACK FOOTER //
// ./src/actions/diff.actions.js